import { containers, elements, overlays } from '@ecosystem/newron-design-system';
import React, { useContext, useMemo, useState } from 'react';

import { Slide } from '../../common';
import { UpsellContext, actions } from '../../state';

import './UpsellModal.css';

type UpsellModalProps = {
  slides: Slide[];
  size?: 'small' | 'default' | 'big';
  onCloseTrack?: (index: number) => void;
  showModal?: boolean;
};

export const UpsellModal = ({ slides = [], size = 'default', onCloseTrack }: UpsellModalProps): JSX.Element => {
  const [slideIndex, setSlideIndex] = useState(1);
  const { Modal } = overlays;
  const { Carousel } = containers;
  const { Icon } = elements;
  const { state, dispatch } = useContext(UpsellContext);
  const carouselSlides = useMemo(() => slides.map((slide: Slide) => slide.component), [slides]);

  if (slides.length === 0) {
    return null;
  }

  return (
    <>
      <div className={`upsell-modal upsell-modal-${size} ${state.singleSlide ? 'upsell-modal--without-footer' : ''}`}>
        <Modal isOpen={state.isModalOpen} size="xl">
          <div className="px-6 py-4 border-b border-light rounded-t flex justify-between">
            <span className="text-xl font-bold h-8">{slides[slideIndex]?.headline || ''}</span>
            <button
              onClick={() => {
                onCloseTrack && onCloseTrack(slideIndex + 1);
                dispatch(actions.setIsModalOpen(false));
              }}
              data-test-id="close-info-box"
            >
              <Icon color="brand">
                <Icon.icons.Close />
              </Icon>
            </button>
          </div>
          <div className={`upsell-carousel upsell-carousel-${size}`}>
            {state.singleSlide && (
              <Carousel
                slides={[state.singleSlide] as unknown as React.ReactElement[]}
                onChangeSlide={slideIndex => {
                  setSlideIndex(slideIndex);
                  dispatch(actions.setActiveSlideIndex(slideIndex));
                }}
              />
            )}
            {!state.singleSlide && (
              <Carousel
                slides={carouselSlides as unknown as React.ReactElement[]}
                onChangeSlide={slideIndex => {
                  setSlideIndex(slideIndex);
                  dispatch(actions.setActiveSlideIndex(slideIndex));
                }}
              />
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};
